const firebaseConfig = {
    apiKey: "AIzaSyCF3iRKjAbE87JqO-xrJxKx7kyWzf998Oo",
    authDomain: "volunteer-network-77792.firebaseapp.com",
    databaseURL: "https://volunteer-network-77792.firebaseio.com",
    projectId: "volunteer-network-77792",
    storageBucket: "volunteer-network-77792.appspot.com",
    messagingSenderId: "188038941265",
    appId: "1:188038941265:web:853f7a0b52f2a65652c670"
  };
  export default firebaseConfig;